import type { Mesh } from 'three'
import { toCreasedNormals } from 'three/examples/jsm/utils/BufferGeometryUtils.js'

export default function creaseMeshGeometryNormals(mesh: Mesh) {
  mesh.geometry = toCreasedNormals(mesh.geometry)
}